import createFormValues from './createFormValues';
import plain from './structure/plain';

export default createFormValues(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/formValues.js
// module id = 2204
// module chunks = 1